import { View, Accordion, Disclosure, DisclosureTitle, DisclosurePanel, Flex, DateField, TextArea, ComboBox, Checkbox, DatePicker, Heading, Divider, ActionButton } from '@adobe/react-spectrum';
import { Item } from '@react-stately/collections';
import React, { useEffect, useRef, useState } from 'react';
import { ContactFormData } from '../AddNewPerson';
import { CalendarDate,parseDate } from '@internationalized/date';
import { Check, ExclamationTriangle } from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';

export const ConsentSection: React.FC<{
  data: ContactFormData['consent'];
  onChange: (data: ContactFormData['consent']) => void;
  expandedSectionKey:any
  setExpandedSectionKey:(data:any)=>void;
  validationErrors:any
  setValidationErrors : (data:any)=>void;
  fieldConfig:any
  validationStatus:any
  setValidationStatus:(data:any)=>void;
}> = ({ data, onChange,expandedSectionKey,setExpandedSectionKey,validationErrors,
  setValidationErrors,
  fieldConfig,
  validationStatus,
  setValidationStatus }) => {
  const [isSectionRequired,setIsSectionRequired] = useState(false);
  const handleSectionExpandedChange = () => {
    setExpandedSectionKey((prevKey:any) => prevKey.has("consentSection") ? new Set() : new Set(["consentSection"]));
  };
  const inputRef = useRef<any>(null);
      useEffect(() => {
      if (expandedSectionKey?.has?.("consentSection")) {
        setTimeout(() => {
          inputRef.current?.focus();
        }, 200); 
      }
    }, [expandedSectionKey]);
  const handleConfirm = ()=>{
    setExpandedSectionKey(new Set(['personSection']))
  }
  const { t } = useTranslation('contacts');
  const _t = (key: string) => t(`addNewPerson.${key}`, { ns: 'contacts' });
  const _tt = (key: string) => t(`contact_common.${key}`, { ns: 'contacts' });
  return (
    <Accordion isQuiet expandedKeys={expandedSectionKey} onExpandedChange={handleSectionExpandedChange}>
          <Disclosure id={'consentSection'}>
            <DisclosureTitle>
              <Flex justifyContent="space-between" alignItems="center" width="100%">
                                <View><span>{_t(`personal_data_protection`)}</span><span style={{color:'#B0BEC5',fontFamily:'Adobe Clean'}}>{isSectionRequired && ` (${_tt('required')})`}</span></View>
                {validationStatus.consentSection ? <Check size={20} color="#1976D2" /> :<ExclamationTriangle size={20} color="#FF9800" />}
              </Flex>
            </DisclosureTitle>
            <DisclosurePanel>
            <Divider size='M' UNSAFE_style={{marginBottom:10}}/>
            <Flex direction="column" gap="size-100" width='100%'>
              <Flex direction={{base:'column',L:'row'}} gap={'size-100'}>
              <ComboBox
              label={_t("consent_status")}
              ref={inputRef}
              selectedKey={data.status}
              onSelectionChange={(status) => onChange({ ...data, status: status ? status.toString() : "" })}
              width='100%'
            >
              <Item key="1">Unknown</Item>
              <Item key="2">Selected for update</Item>
              <Item key="3">Update pending</Item>
              <Item key="4">Valid</Item>
              <Item key="5">Expired</Item>
              <Item key="6">Erasure requested</Item>
              <Item key="7">Forgotten requested</Item>
            </ComboBox>
            <DatePicker
              label={_t("consent_provided")}
              value={data.provided ? parseDate(data.provided) : undefined}
              onChange={(date) => onChange({ ...data, provided: date?.toString() || '' })}
              width='100%' />
            <DatePicker
              label={_t("consent_expiration")}
              value={data.expiration ? parseDate(data.expiration) : undefined}
              onChange={(date) => onChange({ ...data, expiration: date?.toString() || '' })}
              width='100%' />
              </Flex>
            <TextArea
              label={_t("consent_note")}
              value={data.note}
              onChange={(note) => onChange({ ...data, note })}
              width='100%' />
              <Flex direction="row" gap={'size-100'} marginTop={10} justifyContent='space-between'>
              <Checkbox
              isSelected={data.isAnonymized}
              onChange={(isAnonymized) => onChange({ ...data, isAnonymized })}
            >
              {_t('anonymized')}
            </Checkbox>
                    <View>
                      <ActionButton onPress={handleConfirm} isQuiet UNSAFE_style={{color:'#1976D2',padding:10}}><Check size={22} color='#1976D2' /> {_tt('button_confirm')}</ActionButton>
                    </View>
              </Flex>
          </Flex>
              <Divider size='M' UNSAFE_style={{marginTop:10}}/>
            </DisclosurePanel>
          </Disclosure>
          </Accordion>
  )
}
